{
  "chart": {
    "how-to-measure": "So messen Sie",
    "select-your-size-we-ll-notify-you-once-it-s-back-in-stock": "Wählen Sie Ihre Größe, wir benachrichtigen Sie, sobald sie wieder verfügbar ist"
  },
  "page": {
    "plans": {
      "try-now": "Jetzt testen",
      "what-included": "Was ist enthalten?",
      "popular-plan": "Beliebt"
    },
    "about-us": {
      "title": "Über uns",
      "intro": "Goodchart wurde 2023 mit der Mission gegründet, Ihr Einkaufserlebnis für Kleidung zu verändern. Unser Team aus Modebegeisterten, Designern und Technologieexperten ist hier, um Ihnen zu helfen, Kleidung zu finden, die wirklich zu Ihrem Körper passt. Mit unserer benutzerfreundlichen Oberfläche und fortschrittlichen Algorithmen bieten wir personalisierte Empfehlungen basierend auf Ihren Maßen, Ihrem Stil und Lebensstil.",
      "community": "Verabschieden Sie sich von Kompromissen und begrüßen Sie Selbstvertrauen und Komfort. Werden Sie Teil unserer inklusiven Gemeinschaft zufriedener Kunden und begeben Sie sich mit Goodchart auf eine freudvolle Einkaufsreise.",
      "tagline": "Entfalten Sie Ihren Stil. Erleben Sie pure Mode-Euphorie.",
      "founders": "Gründer",
      "cedric-photo-alt": "Cedric, Goodchart-Mitgründer und Produktleiter",
      "nick-photo-alt": "Nick, Goodchart-Mitgründer und Betriebsleiter",
      "quentin-photo-alt": "Quentin, IT-Leiter bei Goodchart",
      "cedric": "Cedric",
      "cedric-role": "Goodchart-Mitgründer und Produktleiter",
      "nick": "Nick",
      "nick-role": "Goodchart-Mitgründer und Betriebsleiter",
      "quentin": "Quentin",
      "quentin-role": "IT-Leiter bei Goodchart"
    },
    "contact": {
      "title": "Kontaktieren Sie uns",
      "lets-talk": "Lassen Sie uns sprechen",
      "subtitle": "Füllen Sie das Formular aus, und unser Team meldet sich per E-Mail bei Ihnen.",
      "first-name": "Vorname",
      "first-name-required": "Vorname ist erforderlich",
      "last-name": "Nachname",
      "last-name-required": "Nachname ist erforderlich",
      "email": "E-Mail",
      "email-required": "E-Mail ist erforderlich",
      "email-invalid": "Bitte geben Sie eine gültige E-Mail-Adresse ein",
      "message": "Nachricht",
      "message-required": "Nachricht ist erforderlich",
      "sending": "Wird gesendet...",
      "send": "Senden",
      "success": "Ihr Formular wurde an unser Team gesendet!"
    },
    "email-unsubscribe": {
      "title": "E-Mail-Abonnement",
      "unsubscribe-confirm": "Möchten Sie sich wirklich von unserem Newsletter abmelden?",
      "unsubscribe-info": "Wenn Sie sich abmelden, erhalten Sie keine Updates, Newsletter und Sonderangebote mehr von uns.",
      "cancel": "Abbrechen",
      "confirm-unsubscription": "Abmeldung bestätigen",
      "resubscribe-confirm": "Möchten Sie sich wieder für unseren Newsletter anmelden?",
      "resubscribe-info": "Bleiben Sie mit unseren neuesten Nachrichten, exklusiven Angeboten und spannenden Updates auf dem Laufenden.",
      "resubscribe": "Wieder anmelden",
      "unsubscribe-success": "Ihre E-Mail wurde erfolgreich abgemeldet",
      "unsubscribe-error": "Beim Abmelden Ihrer E-Mail ist ein Problem aufgetreten",
      "resubscribe-success": "Ihre E-Mail wurde erfolgreich wieder angemeldet",
      "resubscribe-error": "Beim erneuten Anmelden Ihrer E-Mail ist ein Problem aufgetreten"
    },
    "back-to-stock": {
      "notify-me-product": "Benachrichtigen Sie mich für das Produkt {{title}} - {{variant}}"
    },
    "help": {
      "title": "Hilfezentrum",
      "description": "Anleitungen zur Einrichtung und Nutzung von Goodchart in Ihrem Shopify-Shop.",
      "search": "Hilfeartikel durchsuchen",
      "loading": "Wird geladen…",
      "load-failed": "Das Hilfezentrum konnte nicht geladen werden. Bitte versuchen Sie es gleich noch einmal.",
      "no-results": "Keine Artikel entsprechen Ihrer Suche.",
      "no-articles": "Es gibt noch keine Hilfeartikel.",
      "topics": {
        "getting-started": "Erste Schritte",
        "size-charts": "Größentabellen",
        "table-charts": "Tabellen",
        "assigning-products": "Produkte zuweisen",
        "storefront-display": "Anzeige im Shop",
        "chart-import": "Tabellenimport",
        "size-recommendations": "Größenempfehlungen",
        "plans-billing": "Tarife & Abrechnung",
        "troubleshooting": "Fehlerbehebung"
      },
      "back": "Zurück zum Hilfezentrum",
      "browse": "Zum Hilfezentrum",
      "not-found": {
        "title": "Artikel nicht gefunden",
        "description": "Dieser Artikel existiert nicht oder ist nicht mehr verfügbar."
      },
      "updated": "Zuletzt aktualisiert am {{date}}",
      "related": "Mehr zu {{topic}}",
      "contact": {
        "title": "Brauchen Sie weitere Hilfe?",
        "description": "Senden Sie uns eine Nachricht, und unser Team antwortet Ihnen per E-Mail. Wenn Sie die Goodchart-App installiert haben, können Sie auch im Support-Chat der App fragen.",
        "link": "Kontaktieren Sie uns"
      },
      "article-load-failed": "Dieser Artikel konnte nicht geladen werden. Bitte versuchen Sie es gleich noch einmal."
    }
  },
  "error": {
    "error-occurred": "Es ist ein Fehler aufgetreten!",
    "failed-to-subscribe-to-this-product": "Abonnieren dieses Produkts fehlgeschlagen!",
    "failed-to-get-your-size-recommendation-please-try-again-later": "Ihre Größenempfehlung konnte nicht abgerufen werden. Bitte versuchen Sie es später erneut."
  },
  "common": {
    "close": "Schließen"
  },
  "component": {
    "size-recommender": {
      "form": {
        "title": "Finden Sie Ihre beste Größe",
        "subtitle": "Ein paar schnelle Details für eine bessere Passform",
        "shopping-for": "EINKAUFEN FÜR",
        "gender-women": "Damen",
        "gender-men": "Herren",
        "gender-other": "Andere",
        "measurements": "MASSE",
        "height": "Größe",
        "height-required": "Größe ist erforderlich",
        "height-min": "Mindestgröße ist 1",
        "weight": "Gewicht",
        "weight-required": "Gewicht ist erforderlich",
        "weight-min": "Mindestgewicht ist 1",
        "preferred-fit": "Bevorzugte Passform",
        "continue": "Fortfahren"
      },
      "result": {
        "suggested-size": "Vorgeschlagene Größe:",
        "no-fit": "Leider scheinen wir derzeit keine ideale Größe zu haben. Wir empfehlen, später erneut nach weiteren Optionen zu schauen.",
        "verdict": "Ergebnis:",
        "similar-variants": "Ähnliche Varianten:",
        "proceed": "Mit dieser Variante fortfahren",
        "estimate-disclaimer": "(Schätzung basierend auf Marke und Benutzerinformationen, Ergebnisse können variieren.)",
        "back": "Zurück"
      }
    },
    "footer": {
      "terms": "AGB",
      "privacy": "Datenschutz",
      "help-center": "Hilfezentrum",
      "blog": "Blog",
      "about": "Über uns",
      "contact-us": "Kontaktieren Sie uns"
    },
    "conversion-table": {
      "description": "Je nach Passform können leichte Abweichungen bei den Maßen auftreten. Finden Sie Ihre richtige Größe in der Tabelle unten.",
      "size": "Größe"
    },
    "add-to-cart-btn": {
      "notify-me-when-available": "Benachrichtigen Sie mich, wenn verfügbar",
      "notify-me": "Benachrichtigen Sie mich",
      "out-of-stock": "Nicht auf Lager"
    },
    "restock-form": {
      "your-name": "Ihr Name",
      "your-email": "Ihre E-Mail-Adresse",
      "email-required": "E-Mail ist erforderlich",
      "subscribing": "Wird angemeldet...",
      "notify-me": "BENACHRICHTIGEN SIE MICH",
      "agree-terms": "Wenn Sie fortfahren, stimmen Sie unseren",
      "terms-privacy": "Nutzungsbedingungen und Datenschutzrichtlinien zu",
      "news-opt-in": "Ich möchte Updates zu neuen Produkteinführungen und anderen inspirierenden Inhalten erhalten (optional)"
    },
    "back-to-stock-result": {
      "new-subscription": "Vielen Dank, wir senden Ihnen eine E-Mail, sobald die Größe <span class=\"font-bold\">{{name}}</span> verfügbar ist.",
      "existing-subscription": "Wir haben Ihre E-Mail! Wir informieren Sie, sobald die Größe <span class=\"font-bold\">{{name}}</span> wieder auf Lager ist.",
      "back-to-collection": "Zurück zur Kollektion"
    },
    "chart": {
      "find-your-size": "Finden Sie Ihre Größe",
      "size-guide": "Größentabelle",
      "recommendation": "Empfehlung",
      "body-measurements": "KÖRPERMASSE",
      "model-measurements": "MODELLMASSE",
      "model-description": "Model {{name}} ist {{height}}cm groß und trägt Größe {{variant}}.",
      "size-conversion": "GRÖSSENUMRECHNUNG"
    },
    "landing": {
      "learn": "Lernen",
      "learn-more": "Mehr erfahren",
      "blog": "Blog",
      "blog-description": "Entdecken Sie die neuesten Ankündigungen, Produktupdates und mehr",
      "help-center": "Hilfezentrum",
      "help-center-description": "Erste Schritte, Anleitungen und Schritt-für-Schritt-Anweisungen",
      "demo": "Demo",
      "demo-description": "Sehen Sie Goodsize-Widgets in Aktion in unserem Beispielshop",
      "services": "DIENSTLEISTUNGEN",
      "contact": "Kontakt",
      "privacy": "Datenschutz",
      "goodsize": "Goodsize",
      "goodsize-description": "Entdecken Sie unsere Passform-Lösung für Ihr Unternehmen",
      "goodchart": "Goodchart",
      "goodchart-description": "Visuelle Größentabelle zur Steigerung der Konversion"
    },
    "product-variant-completer": {
      "title": "Wählen Sie Ihre Optionen",
      "body": "Wählen Sie Ihre {{option}}, um fortzufahren.",
      "body-multiple": "Wählen Sie die restlichen Optionen, um fortzufahren.",
      "body-notify": "Welche {{option}} sollen wir für Sie beobachten?",
      "confirm": "Weiter",
      "cancel": "Abbrechen",
      "empty": "Diese Kombination ist nicht verfügbar."
    },
    "checkout-variant": {
      "label": "Sie kaufen {{variant}}",
      "aria-label": "Zu kaufende Variante ändern",
      "sold-out": "ausverkauft"
    }
  },
  "promotion": {
    "BlackFriday": {
      "name": "Black Friday"
    }
  }
}
